<template>
    <div>
        <p>
            Gemäß den Artikeln 1341 und 1342 des italienischen Zivilgesetzbuches erklärt der Nutzer ausdrücklich, die folgenden Klauseln gelesen,
            verstanden und akzeptiert zu haben:
        </p>
        <p>Art. 1 Begriffsbestimmungen, Buchst. l), „Fleequid“, Rechtsträger und anwendbares Steuerrecht;</p>
        <p>Art. 2.3 Provisionen sowohl zulasten des Verkäufers als auch des Käufers;</p>
        <p>Art. 2.4 Auktionsmodalitäten und Festlegung des Zuschlagspreises;</p>
        <p>Art. 2.5 Weiterverkaufsprozess;</p>
        <p>
            Art. 3 Genehmigung etwaiger von Nutzern vorgeschlagener Allgemeiner Geschäftsbedingungen, einseitige Änderung der AGB durch Fleequid und
            Rangfolge der Vertragsdokumente;
        </p>
        <p>Art. 4.5 Beschränkungen der Nutzung des Marketplace;</p>
        <p>Art. 4.6 Maßnahmen von Fleequid bei Verstößen gegen die Nutzungsregeln;</p>
        <p>Art. 4.7 Kündigung / Auflösung;</p>
        <p>Art. 4.8 Vertragsstrafe;</p>
        <p>Art. 4.10 Haftungsausschluss für das Funktionieren des Marketplace;</p>
        <p>Art. 4.11 Löschung des Nutzerprofils und Ausübung des Widerrufsrechts;</p>
        <p>
            Art. 6 betreffend: ausdrückliche Auflösungsklausel, Verkaufs-Exklusivität, Bedingungen und Dauer dieser Exklusivität, Möglichkeit einer
            nachfolgenden Zuschlagserteilung, Verkaufsbeschränkungen, Möglichkeit der Annullierung oder Auflösung des Verkaufs bei verspäteter oder
            ausbleibender Zahlung des Käufers, Verzicht des Verkäufers auf Einwendungen oder Ansprüche, Freistellung, technisches Dossier,
            Vertragsstrafen zulasten des Verkäufers;
        </p>
        <p>
            Art. 7 Einladung zur Angebotsabgabe (invitatio ad offerendum), Dauer des unwiderruflichen Kaufangebots, besondere Auktionsbedingungen,
            Mindestpreis;
        </p>
        <p>Art. 8.4 Behandlung der Sicherheitsleistung;</p>
        <p>Art. 9.3 Zahlung des Fahrzeugpreises;</p>
        <p>
            Art. 9.4 Vorzeitige Rechnungsstellung auf Anfrage von Fleequid, aufschiebende Bedingung der Zahlung abhängig vom vollständigen
            Zahlungseingang des Käufers (pay-when-paid), Verpflichtung zur Ausstellung einer Gutschrift bei Nichtzahlung oder Annullierung des
            Verkaufs, Aufrechnungsrecht, tägliche Vertragsstrafen bei Verzögerungen oder Unterlassungen sowie Verzicht des Verkäufers auf Einwendungen
            oder Ansprüche gegenüber Fleequid;
        </p>
        <p>Art. 9.5 Vertragsstrafe;</p>
        <p>Art. 9.7 und 9.8 Fristen zur Anzeige von Mängeln und Fehlern;</p>
        <p>Art. 9.10 Ausdrückliche Auflösungsklausel und Vertragsstrafe;</p>
        <p>
            Art. 10 Zahlungsbedingungen, Kündigung, Vertragsstrafen, Bedingungen für den Weiterverkauf und Haftungsfreistellung, Kilometerstand,
            Fristen zur Mängelprüfung bei Übergabe;
        </p>
        <p>
            Art. 11 Ausschluss der Gewährleistung und Haftungsfreistellung von Fleequid, Gefahrübergang, ausdrückliche Auflösungsklausel,
            Vertragsstrafen, Recht zur Annullierung des Verkaufs, Ausschluss versteckter Mängel, Haftungsgrenzen auf Basis von Kilometerstand und
            Fahrzeugalter;
        </p>
        <p>
            Art. 13 Reklamationen, Vorschläge zur Streitbeilegung, Streitbeilegung durch Fleequid mittels Annullierung des Verkaufs, versteckte
            Mängel, Haftungsfreistellung, „wie gesehen und gekauft“-Klausel, Vertragsstrafen;
        </p>
        <p>Art. 14 Verknüpfungsklausel;</p>
        <p>Art. 15 Anwendbares Recht, Sprache und zuständiges Gericht.</p>
    </div>
</template>
